import { range } from "lodash";
import React, { useState, useContext } from "react";
import GMSBorderlessButton from "../../Common/components/GMSBorderlessButton";
import Label from "../../Common/components/Label";
import DatePicker from "../promotions/DatePicker";
import TimePicker from "../promotions/TimePicker";
import RepeatSelect from "./RepeatSelect";
import DatePicker1 from "react-datepicker";
import HourRepeatSchedule from "./HourRepeatSchedule";
import DayRepeatSchedule from "./DayRepeatSchedule";
import WeekRepeatSchdule from "./WeekRepeatSchdule";
import GMSFillButton from "../../Common/components/GMSFillButton";
import { toast } from "react-toastify";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import OverlayIcon from "../../GMS/Rules/Components/OverlayIcon";
import Utils from "../../../Common/Utils";
import { AppContext } from "../../../Context/AppContext";

const MID_WAY_URL = process.env.REACT_APP_CONNECTION_API;

const ScheduleForm = (props) => {
  const { setShowSchedule, validateForm, formData, fetchData } = props;
  const [scheduleInfo, setScheduleInfo] = useState({
    startDate: "",
    startTime: "",
    endDate: "",
    repeat: "Never",
    xDays: "1",
    xHours: "1",
    xWeeks: "1",
    weekly: [],
  });
  
  // const channel_key = "7YWVopW2g7lsfiBtDduy";
  const appData = useContext(AppContext);
  const [weeksInfo, setWeeksInfo] = useState([
    { day: "Sunday", code: 6, displayChar: "S", selected: false },
    { day: "Monday", code: 0, displayChar: "M", selected: false },
    { day: "Tuesday", code: 1, displayChar: "T", selected: false },
    { day: "Wednessday", code: 2, displayChar: "W", selected: false },
    { day: "Thursday", code: 3, displayChar: "T", selected: false },
    { day: "Friday", code: 4, displayChar: "F", selected: false },
    { day: "Saturday", code: 5, displayChar: "S", selected: false },
  ]);
  let weeks = Array.from(range(1, 53));
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const handleScheduleChange = async (id, value) => {
    setScheduleInfo({ ...scheduleInfo, [id]: value });
  };
  const handleWeeklyDataChange = (item, index) => {
    let newArray = [...weeksInfo];
    for (let arr in newArray) {
      if (newArray[arr].code === index) {
        newArray[arr].selected = !newArray[arr].selected;
      }
    }
    setWeeksInfo(newArray);
  };
  const formatEndDate = (date) => {
    // format the date into dd-mm-yyyy
    const day =
      date.getDate() < 10
        ? "0" + String(date.getDate())
        : String(date.getDate());
    const month =
      date.getMonth() + 1 < 10
        ? "0" + String(date.getMonth() + 1)
        : String(date.getMonth() + 1);
    return `${date.getFullYear()}-${month}-${day}`;
  };

  const validateSchedule = () => {
    if (scheduleInfo.startDate === "" || scheduleInfo.startDate === undefined) {
      toast.error("Please select start date");
      return false;
    }

    if (scheduleInfo.startTime === "" || scheduleInfo.startTime === undefined) {
      toast.error("Please select start time");
      return false;
    }

    // Create a UTC Time string and
    // validate if start date is greater that today
    let combineDate =
      scheduleInfo.startDate + "T" + scheduleInfo.startTime + ":00";
    const _start_date = new Date(combineDate);
    const _today_local = new Date();
    let _combineDateToday = Utils.getUTCDateString(_today_local);
    const _today = new Date(_combineDateToday);
    if (_start_date < _today) {
      toast.error(
        "Start date and time should be greater than current time Note: UTC format"
      );
      return false;
    }

    if (scheduleInfo.repeat !== "Never") {
      if (scheduleInfo.endDate === "" || scheduleInfo.endDate === undefined) {
        toast.error("Please select end date");
        return false;
      }

      const _end_date = new Date(scheduleInfo.endDate);
      // check if end date is greater that start date
      if (scheduleInfo.repeat === "HOUR") {
        if (_end_date < _start_date) {
          toast.error("End date should be greater or equal to start date");
          return false;
        }
      } else {
        if (_end_date <= _start_date) {
          toast.error("End date should be greater than start date");
          return false;
        }
      }
    }
    return true;
  };

  function buildScheduleData(data) {
    let date = scheduleInfo.startDate;
    let time = scheduleInfo.startTime;

    let timeAndDate = date + "T" + time + ":00Z";

    let scheduleDetail = {
      ...data,
      startDate: new Date(timeAndDate).toISOString(),
      runAtVal: 0,
      runAtInterval: scheduleInfo.repeat,
      repeat: scheduleInfo.repeat,
      runOnDay: [1],
    };

    if (scheduleInfo.endDate !== "") {
      scheduleDetail.endDate = new Date(scheduleInfo.endDate).toISOString();
    }

    if (scheduleInfo.repeat === "HOUR") {
      scheduleDetail.runAtInterval = scheduleInfo.repeat;
      scheduleDetail.runAtVal = parseInt(scheduleInfo.xHours, 0);
    }

    if (scheduleInfo.repeat === "DAY") {
      scheduleDetail.runAtInterval = scheduleInfo.repeat;
      scheduleDetail.runAtVal = parseInt(scheduleInfo.xDays, 0);
    }

    if (scheduleInfo.repeat === "WEEK") {
      let days = [];
      for (let selected in weeksInfo) {
        if (weeksInfo[selected].selected === true) {
          days.push(weeksInfo[selected].code);
        }
      }
      scheduleDetail.runAtInterval = scheduleInfo.repeat;
      scheduleDetail.runAtVal = parseInt(scheduleInfo.xWeeks, 0);
      scheduleDetail.runOnDay = days;
    }
    return scheduleDetail;
  }

  const createShedule = async () => {
    if (!validateForm()) return;
    if (!validateSchedule()) return;

    let scheduleDetail = buildScheduleData({ ...formData });

    let res = await ServiceWrapper.doPost(
      `${MID_WAY_URL}connection/${appData?.channelKey}/schedule`,
      scheduleDetail,
      null,
      AuthManager.getGmsToken()
    );

    if (res?.data?.done) {
      toast.success("Schedule Data Import created successfully");
      fetchData();
      props.closeForm();
    } else {
      toast.error(res?.data?.message ?? "Data import shedule failed.");
    }
  };

  const createImport = async () => {
    if (!validateSchedule()) return;
    if (!validateForm()) return;

    let date = scheduleInfo.startDate;
    let time = scheduleInfo.startTime;
    let combineDate = date + "T" + time + ":00Z";
    let timeAndDate = new Date(combineDate).toISOString();

    let data = {
      ...formData,
      startDate: timeAndDate,
      repeat: "NEVER",
    };

    let res = await ServiceWrapper.doPost(
      `${MID_WAY_URL}connection/${appData?.channelKey}/schedule`,
      data,
      null,
      AuthManager.getGmsToken()
    );

    if (res?.data?.done) {
      toast.success("Schedule Data Import created successfully");
      fetchData();
      props.closeForm();
    } else {
      toast.error(res?.data?.message ?? "Data import shedule failed.");
    }
  };

  return (
    <div>
      <div className="mt-3 d-flex justify-content-between align-items-center me-3">
        <label className="schedule-title">
          Schedule Import &nbsp;
          <OverlayIcon message="The scheduled import will reflect after “XX” hours of the set UTC date and time. For example, If the import is set for every Monday at 2 PM and the recurring time interval is 2 hours, then the import will start reflecting at 4 PM." />
        </label>
        <GMSBorderlessButton
          name={"Cancel"}
          onClick={() => setShowSchedule(false)}
        />
      </div>
      <div className="mt-3 d-flex">
        <div>
          <label className="form-caption">Start Date</label>
          <div className="pt-1 pb-1"></div>
          <DatePicker
            dateValue={scheduleInfo.startDate}
            scheduleInfo={scheduleInfo}
            setStartDate={setScheduleInfo}
          />
        </div>
        <div className="ms-4">
          <label className="form-caption">Start Time(UTC)</label>
          <div className="pt-1 pb-1"></div>
          <TimePicker
            timeValue={scheduleInfo.startTime}
            scheduleInfo={scheduleInfo}
            setTimeValue={setScheduleInfo}
          />
        </div>
      </div>
      <div className="mt-3">
        <div>
          <label className="form-caption">Repeat</label>
          <div className="items-center d-flex align-items-center">
            <div className="mt-2 border-0 input-group w-25">
              <select
                className="shadow-none fst-normal ps-3 pe-3 form-select drop-down-style drop-down-style-repeat"
                id="repeat"
                placeholder="Never"
                value={scheduleInfo.repeat}
                onChange={(e) => {
                  handleScheduleChange(e.target.id, e.target.value);
                }}
              >
                <option value={"Never"}>Never</option>
                <option value={"HOUR"}>Hourly</option>
                <option value={"DAY"}>Daily</option>
                <option value={"WEEK"}>Weekly</option>
              </select>
            </div>
            {scheduleInfo.repeat === "HOUR" && (
              <RepeatSelect
                labelMessage={scheduleInfo.repeat}
                selectId="xHours"
                selectValue={scheduleInfo.xHours}
                selectOptions={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
                onChange={(e) =>
                  handleScheduleChange(e.target.id, e.target.value)
                }
              />
            )}

            {scheduleInfo.repeat === "DAY" && (
              <RepeatSelect
                labelMessage={scheduleInfo.repeat}
                selectId="xDays"
                selectValue={scheduleInfo.xDays}
                selectOptions={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
                onChange={(e) =>
                  handleScheduleChange(e.target.id, e.target.value)
                }
              />
            )}

            {scheduleInfo.repeat === "WEEK" && (
              <RepeatSelect
                labelMessage={scheduleInfo.repeat}
                selectId="xWeeks"
                selectValue={scheduleInfo.xWeeks}
                selectOptions={weeks}
                onChange={(e) =>
                  handleScheduleChange(e.target.id, e.target.value)
                }
              />
            )}
          </div>
          {scheduleInfo.repeat === "HOUR" && (
            <HourRepeatSchedule
              scheduleInfo={scheduleInfo}
              openDatePicker={openDatePicker}
              setOpenDatePicker={setOpenDatePicker}
              setScheduleInfo={setScheduleInfo}
              formatEndDate={formatEndDate}
              Label={Label}
              GMSBorderlessButton={GMSBorderlessButton}
              DatePicker1={DatePicker1}
            />
          )}
          {scheduleInfo.repeat === "DAY" && (
            <DayRepeatSchedule
              scheduleInfo={scheduleInfo}
              openDatePicker={openDatePicker}
              setOpenDatePicker={setOpenDatePicker}
              setScheduleInfo={setScheduleInfo}
              formatEndDate={formatEndDate}
              Label={Label}
              GMSBorderlessButton={GMSBorderlessButton}
              DatePicker1={DatePicker1}
            />
          )}
          {scheduleInfo.repeat === "WEEK" && (
            <WeekRepeatSchdule
              repeat={scheduleInfo.repeat}
              weeksInfo={weeksInfo}
              scheduleInfo={scheduleInfo}
              openDatePicker={openDatePicker}
              handleWeeklyDataChange={handleWeeklyDataChange}
              formatEndDate={formatEndDate}
              setOpenDatePicker={setOpenDatePicker}
              setScheduleInfo={setScheduleInfo}
            />
          )}
        </div>
      </div>
      <div className="mt-3">
        <GMSFillButton
          name={"Schedule Import "}
          // disabled={disableButton}
          onClick={() => {
            if (scheduleInfo.repeat === "Never") {
              createImport();
            } else {
              createShedule();
            }
          }}
        />
      </div>
    </div>
  );
};

export default ScheduleForm;
